import { gql } from 'apollo-angular';

export const OFFER_TEMPLATE_SETTINGS_FRAGMENT = gql`
  fragment OfferTemplateSettingsFragment on OfferTemplateSettings {
    id
    content
    displayPictures
    displayConditions
    displayPrices
    showElementPriceOnly
    footer { ...OfferTemplateSettingsItemFragment }
    logo { ...OfferTemplateSettingsItemFragment }
    pdfFirstPage { ...OfferTemplateSettingsItemFragment }
    pdfFirstPagePreview { ...OfferTemplateSettingsItemFragment }
    pdfFollowingPages { ...OfferTemplateSettingsItemFragment }
    pdfFollowingPagesPreview { ...OfferTemplateSettingsItemFragment }
  }
  fragment OfferTemplateSettingsItemFragment on OfferTemplateSettingsItem {
    type
    text
    imageUrls {
      download
      upload
    }
  }
`;
